import LabeledSelect from '../../../components/selects/LabeledSelect'
import { debounce, isEmpty } from 'lodash'
import { useCallback } from 'react'
import { requestProductInfoGet } from 'redux/sagas/requests/prescriptionService'

const ProductSearch = ({
  label,
  value,
  onChange,
  placeholder = 'Search Product',
  emptyMsg = 'No data',
  ...props
}) => {
  const handleSearchProduct = (input) => {
    if (isEmpty(input)) {
      return []
    }

    return requestProductInfoGet(input).then((response) =>
      response.data ? response.data : [],
    )
  }

  // noinspection JSCheckFunctionSignatures
  const debouncedSearchUser = useCallback(
    debounce((inputText, callback) => {
      handleSearchProduct(inputText).then((options) => callback(options))
    }, 500),
    [handleSearchProduct],
  )

  return (
    <LabeledSelect
      label={label}
      value={value}
      getOptionValue={(option) => option?.default_unit}
      placeholder={placeholder}
      onChange={onChange}
      emptyMsg={emptyMsg}
      getOptionLabel={(option) =>
        `${option?.label}\n
${option?.variant_values
          ? Object.entries(option?.variant_values)
            .map(([key, value]) => `${key}: ${value}`)
            .join(' ')
          : ''
        }`
      }
      {...props}
      loadOptions={debouncedSearchUser}
      components={{
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
      }}
    />
  )
}

export default ProductSearch
